import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './HomePage/HomePage';
import { Landing } from './Landing/Landing';
import { LegacySkyscraperPage } from './legacy/LegacySkyscraperPage';
import { LegacyBanner } from './PreviewBanner';
import { SiteHeader } from './components/SiteHeader';
import { showLegacySite } from './previewFlag';

function App() {
  // Read once at mount. Switching requires a reload, which keeps the change
  // deliberate rather than something that can happen mid render.
  const legacy = showLegacySite();

  if (legacy) {
    // Opt in fallback at ?legacy=1. Kept so the old dashboard stays reachable
    // without a redeploy if anything on the new site needs comparing against.
    return (
      <div className="App">
        <div className="App-header">
          <LegacySkyscraperPage />
        </div>
        <LegacyBanner />
      </div>
    );
  }

  // The current public site.
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/dashboard"
            element={
              <>
                {/* SiteHeader carries id="site-header" itself. That id is what
                    Cloudscape AppLayout offsets against through headerSelector,
                    so the dashboard chrome does not sit underneath the header.
                    Do not wrap it in a div, that breaks its sticky positioning. */}
                <SiteHeader />
                <div className="App-header">
                  <HomePage />
                </div>
              </>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
